import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import axios from "axios";
import {
  Apiurl,
  GetLocalStorageParsed,
  parseData,
  stringifyData,
} from "../../Pages/utils/page";
import { toast } from "react-toastify";

const ReferralAddressModal = ({
  showAddressModal,
  setShowAddressModal,
  handlePayment,
  selectedAddress,
  setSelectedAddress,
}) => {
  const FetchToken = GetLocalStorageParsed("AuthToken");

  const [loginToken, setLoginToken] = useState(FetchToken || null);

  const [formData, setFormData] = useState({
    mobile: "",
    pincode: "",
    address: "",
    locality: "",
    city: "",
    state: "",
    landmark: "",
    altPhoneNumber: "",
  });
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const [showNewAddress, setShowNewAddress] = useState(false);
  const [addressList, setAddressList] = useState([]);

  const handleClose = () => {
    setShowAddressModal();
    setShowNewAddress(false);
  };

  const fetchAddressList = () => {
    const option = {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      url: `${Apiurl()}/api/Customer/FetchDeliveryAddressList`,
    };
    axios(option)
      .then((e) => {
        const data = parseData(e?.data?.result);
        setSelectedAddress(data?.find((i) => i?.IsDefault === true));
        setAddressList(data);
      })
      .catch((error) => {});
  };
  useEffect(() => {
    if (showAddressModal?.Id || showAddressModal) {
      fetchAddressList();
    }
  }, [showAddressModal]);
  const validateAddress = () => {
    const phonePattern = /^\d{10}$/;
    const pincodePattern = /^\d{6}$/;

    if (!formData.mobile || !formData.mobile.match(phonePattern)) {
      toast.error("Please enter a valid mobile number");
      return false;
    }
    if (!formData.pincode.match(pincodePattern)) {
      toast.error("Please enter a valid 6-digit pincode");
      return false;
    }
    if (!formData?.address || formData?.address?.trim() === "") {
      toast.error("Please enter address");
      return false;
    }
    if (!formData?.locality || formData?.locality?.trim() === "") {
      toast.error("Please enter locality");
      return false;
    }
    if (!formData?.city || formData?.city?.trim() === "") {
      toast.error("Please enter city");
      return false;
    }
    if (!formData?.state || formData?.state?.trim() === "") {
      toast.error("Please enter state");
      return false;
    }
    return true;
  };
  const handleSaveAddress = () => {
    if (!validateAddress()) return;
    const data = {
      Id: null,
      PhoneNumber: formData.mobile,
      Pincode: formData.pincode,
      Locality: formData.locality,
      AreaAndStreet: formData.address,
      City: formData.city,
      State: formData.state,
      Landmark: formData.landmark,
      AltPhoneNumber: formData.altPhoneNumber,
      // userId:
    };
    const option = {
      method: "POST",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${loginToken ? loginToken : ""}`,
      },
      data: data,
      url: `${Apiurl()}/api/Customer/AddUpdateDeliveryAddress`,
    };
    axios(option)
      .then((e) => {
        if (e?.data?.status === "OK") {
          toast.success(e?.data?.message);
        }
        if (e?.data?.status === "BadRequest") {
          toast.error(e?.data?.message);
        }
        fetchAddressList();
        setShowNewAddress(false);
      })
      .catch((error) => {});
  };
  return (
    <>
      <Modal
        show={showAddressModal?.Id || showAddressModal}
        onHide={handleClose}
        backdrop="static"
      >
        {!showNewAddress ? (
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="common_heading mb-0">
                Select Address To Claim Order
              </h4>
              <button
                type="button"
                className="close popup_prode_close_btn"
                onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row align-items-center mb-3">
                <div className="col-lg-6 col-6">
                  <p className="mb-0">
                    <strong>SAVED ADDRESSES</strong>
                  </p>
                </div>
                <div className="col-lg-6 col-6 text-end">
                  <button
                    className="common_btn add_address_ref_btn"
                    onClick={() => setShowNewAddress(true)}
                  >
                    <span>+</span>Add Address
                  </button>
                </div>
              </div>
              {addressList?.map((item, index) => (
                <div className="address-card">
                  <div className="row mb-2">
                    <div className="col-lg-6 col-6">
                      <div className="refferal-add_checkbox">
                        <div className="checkbox_banner check_add_slect">
                          <input
                            type="radio"
                            name="selectedAddress"
                            checked={selectedAddress?.Id === item?.Id}
                            onChange={(e) => setSelectedAddress(item)}
                          />
                        </div>
                        <h6>
                          {item?.PhoneNumber}, {item?.Pincode}, {item?.Locality}
                          , {item?.AreaAndStreet}, {item?.City}, {item?.State}{" "}
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <div className="row mb-2">
                <hr />
                <div className="col-lg-12 col-12">
                  <p className="mb-1">
                    <strong>Product Name:</strong>{" "}
                    {showAddressModal?.RewardName}
                  </p>
                  <p className="mb-0">
                    <strong>Quantity:</strong>{" "}
                    {showAddressModal?.selectedQuantity}
                  </p>
                </div>
              </div>
              <input
                type="button"
                value="Claim Order"
                className="payment_btn common_btn w-100"
                onClick={handlePayment}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="common_heading mb-0">
                  Select Address To Claim Order
                </h4>
                <button
                  type="button"
                  className="close popup_prode_close_btn"
                  onClick={handleClose}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-6 form-group mb-2">
                    <label htmlFor="mobile">10-digit Mobile Number</label>
                    <input
                      type="text"
                      className="form-control"
                      id="mobile"
                      placeholder="Enter your mobile number"
                      maxLength="10"
                      pattern="\d{10}"
                      required
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 form-group mb-2">
                    <label htmlFor="pincode">Pincode</label>
                    <input
                      type="text"
                      className="form-control"
                      id="pincode"
                      placeholder="Enter your pincode"
                      maxLength="6"
                      pattern="\d{6}"
                      required
                      value={formData.pincode}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-2">
                  <label htmlFor="address">
                    Address (Area and Street/House No.)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="address"
                    placeholder="Enter your address"
                    value={formData.address}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label htmlFor="locality">Locality</label>
                  <input
                    type="text"
                    className="form-control"
                    id="locality"
                    placeholder="Enter your locality"
                    value={formData.locality}
                    onChange={handleChange}
                  />
                </div>
                <div className="row">
                  <div className="col-md-6 form-group mb-2">
                    <label htmlFor="city">City</label>
                    <input
                      type="text"
                      className="form-control"
                      id="city"
                      placeholder="Enter your city"
                      value={formData.city}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 form-group mb-2">
                    <label htmlFor="state">State</label>
                    <input
                      type="text"
                      className="form-control"
                      id="state"
                      placeholder="Enter your state"
                      value={formData.state}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group mb-2">
                  <label htmlFor="landmark">Landmark (optional)</label>
                  <input
                    type="text"
                    className="form-control"
                    id="landmark"
                    placeholder="Enter a landmark"
                    value={formData.landmark}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group mb-2">
                  <label htmlFor="altPhoneNumber">
                    Alternative Phone Number (optional)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="altPhoneNumber"
                    placeholder="Alternative Phone Number"
                    value={formData.altPhoneNumber}
                    onChange={handleChange}
                  />
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="common_btn relaunch-btn"
                    onClick={() => setShowNewAddress(false)}
                  >
                    Go Back
                  </button>
                  <button
                    type="button"
                    className="common_btn view-data-btn"
                    onClick={() => handleSaveAddress()}
                  >
                    Save
                  </button>
                </div>
                <input
                  type="button"
                  value="Claim Order"
                  className="payment_btn common_btn w-100"
                />
              </div>
            </div>
          </>
        )}
      </Modal>
    </>
  );
};

export default ReferralAddressModal;
